const getInheritedFilters = (filterBy, filterByProperty) => {
  if (!filterByProperty.length) return [];
  if (!filterBy.length) return filterByProperty;
  return filterByProperty.reduce((acc, property) => {
    const [propName] = property.split('/');
    const filterByMatched = filterBy.filter(filterId => filterId.includes(`${propName}/`));
    if (!filterByMatched.length) acc.push(property);
    return acc;
  }, []);
};
export default getInheritedFilters;
//# sourceMappingURL=get-inherited-filters.js.map